
export const billCalculation = (detailBill) => {
    const tvaMap = [];

    detailBill?.list?.forEach((el) => {
        const tvaRate = el?.tva ?? 0;
        const existingIndex = tvaMap.findIndex((item) => item.tvaRate === tvaRate);

        const quantity = el?.quantity || 0;
        const priseProductHT = el?.prise_product_HT || 0;
        const remise = el?.remise || 0;
        const tva = el?.tva || 0;
        
        const montantHT = Number((priseProductHT * quantity).toFixed(3));
        const montantAfterRemise = Number((montantHT * (1 - remise / 100)).toFixed(3));
        const tvaAmount = Number((montantAfterRemise * (tva / 100)).toFixed(3));
        const totalTTC = Number((montantAfterRemise + tvaAmount).toFixed(3));

        if (existingIndex !== -1) {
            tvaMap[existingIndex].BASE = Number((tvaMap[existingIndex].BASE + montantAfterRemise).toFixed(3));
            tvaMap[existingIndex].TOTAL_TAXE = Number((tvaMap[existingIndex].TOTAL_TAXE + tvaAmount).toFixed(3));
            tvaMap[existingIndex].TOTAL_TCC = Number((tvaMap[existingIndex].TOTAL_TCC + totalTTC).toFixed(3));
        } else {
            tvaMap.push({
                CODE: 'C' + tva,
                TAUX: tva,
                tvaRate: tvaRate,
                BASE: montantAfterRemise,
                TOTAL_TAXE: tvaAmount,
                REMISE: Number((montantHT - montantAfterRemise).toFixed(3)),
                TOTAL_TCC: totalTTC,
            });
        }
    });

    return tvaMap;
};

export const finalTotal = (tvaMap, timbreCount = 0) => {
    let totalHT = 0;
    let totalTCC = 0;
    let totalRemise = 0;
    
    const totalTimbre = timbreCount;
    const ctiAmount = 0;

    for (const item of tvaMap) {
        totalHT = Number((totalHT + item.BASE).toFixed(3));
        totalRemise = Number((totalRemise + (item.REMISE || 0)).toFixed(3));
        totalTCC = Number((totalTCC + item.TOTAL_TCC).toFixed(3));
    }
    
    const totalTCCWithCTI = Number((totalTCC + ctiAmount).toFixed(3));
    const totalTTCWithTimbre = Number((totalTCCWithCTI + totalTimbre).toFixed(3));
    
    return {
        TOTAL_HT: totalHT,
        TOTAL_REMISE: totalRemise,
        TOTAL_TIMBRE: totalTimbre,
        TOTAL_CTI: ctiAmount,
        TOTAL_TCC_WITHOUT_TIMBRE: totalTCCWithCTI,
        TOTAL_TCC: totalTTCWithTimbre,
    };
};

export const total = (detailBill, timbreCount = 0) => {
    const tvaMap = billCalculation(detailBill);
    let totalBase = 0;
    let totalTVA = 0;
    
    tvaMap.forEach((el) => {
        totalBase = Number((totalBase + el.BASE).toFixed(3));
        totalTVA = Number((totalTVA + el.TOTAL_TAXE).toFixed(3));
    });
    
    const totalTimbre = timbreCount;
    
    return (
        <tr className="bt-head-4">
            <td>Total</td>
            <td>{totalBase} DT</td>
            <td></td>
            <td>{Number((totalTVA + totalTimbre).toFixed(3))} DT</td>
        </tr>
    );
};

export const totalNet = (detailBill, timbreCount = 0) => {
    const tvaMap = billCalculation(detailBill);
    let totalProducts = 0;
    
    tvaMap.forEach((el) => {
        totalProducts = Number((totalProducts + el.TOTAL_TCC).toFixed(3));
    });
    
    const totalTimbre = timbreCount;
    return Number((totalProducts + totalTimbre).toFixed(3));
};

// convertNumberToWords stays the same
export const convertNumberToWords = (n) => {
    if (n < 0) return false;
    if (n === 0) return 'Zéro';

    const units = ['', 'Un', 'Deux', 'Trois', 'Quatre', 'Cinq', 'Six', 'Sept', 'Huit', 'Neuf'];
    const teens = [
        'Dix', 'Onze', 'Douze', 'Treize', 'Quatorze', 'Quinze', 
        'Seize', 'Dix-sept', 'Dix-huit', 'Dix-neuf'
    ];
    const tens = [
        '', '', 'Vingt', 'Trente', 'Quarante', 'Cinquante', 
        'Soixante', 'Soixante-dix', 'Quatre-vingts', 'Quatre-vingt-dix'
    ];

    const translate = (num) => {
        let word = '';

        if (num < 10) {
            word = units[num];
        } else if (num < 20) {
            word = teens[num - 10];
        } else if (num < 100) {
            const unit = num % 10;
            const ten = Math.floor(num / 10);
            if (unit === 0) {
                word = tens[ten];
            } else if (ten >= 7 && ten <= 9) {
                const teenUnit = unit;
                if (ten === 7) {
                    word = 'Soixante-' + teens[teenUnit];
                } else if (ten === 8) {
                    word = 'Quatre-vingt-' + units[teenUnit];
                } else {
                    word = 'Quatre-vingt-dix-' + teens[teenUnit];
                }
            } else {
                word = tens[ten] + '-' + units[unit];
            }
        } else if (num < 1000) {
            const hundreds = Math.floor(num / 100);
            const remainder = num % 100;
            word = units[hundreds] + ' Cent';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        } else if (num < 1000000) {
            const thousands = Math.floor(num / 1000);
            const remainder = num % 1000;
            word = translate(thousands) + ' Mille';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        } else {
            const millions = Math.floor(num / 1000000);
            const remainder = num % 1000000;
            word = translate(millions) + ' Million';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        }
        return word.trim();
    };

    const dinar = Math.floor(n / 1000);
    const millimes = n % 1000;
    
    let result = '';
    if (dinar > 0) {
        result += translate(dinar) + ' Dinar';
        if (dinar > 1) result += 's';
    }
    if (millimes > 0) {
        if (dinar > 0) result += ' et ';
        result += translate(millimes) + ' Millime';
        if (millimes > 1) result += 's';
    }
    
    return result;
};